<template>
	<v-dialog
		v-model="showDialog"
		width="500"
		min-height="400"
		persistent
		v-if="entities && entities.length > 0"
	>
		<v-card>
			<v-card-title v-if="template && template.Id">
				Edit Template
			</v-card-title>
			<v-card-title v-else> Add New Template </v-card-title>
			<v-card-text>
				<v-form ref="form">
					<v-select
						dense
						v-model="selectedEntity"
						label="Entity"
						:items="entities"
						item-text="Name"
						item-value="Id"
						:rules="entityRules"
					/>
					<v-text-field
						label="Name"
						v-model="templateName"
						:rules="nameRules"
					/>
				</v-form>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-btn @click.stop="onSave" color="primary">
					<v-icon class="mr-2">mdi-content-save</v-icon>
					Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { TemplateActions } from '../../../store/actions';
import { TemplateGetters } from '../../../store/getters';
export default {
	name: 'TemplateDialog',
	props: {
		showDialog: Boolean,
		template: Object,
	},
	data() {
		return {
			selectedEntity: null,
			templateName: null,
			nameRules: [(v) => !!v || 'Name is required'],
			entityRules: [(v) => !!v || 'An Entity must be selected'],
		};
	},
	computed: {
		...mapGetters({
			entities: [TemplateGetters.ENTITIES],
		}),
	},
	mounted() {
		this.$store.dispatch(TemplateActions.LOAD_ENTITIES);
		if (this.template) {
			this.templateName = this.template.Name;
			this.selectedEntity = this.template.EntityId;
		}
	},
	destroyed() {
		this.$store.dispatch(TemplateActions.CLEAR_TEMPLATE_MODAL);
	},
	methods: {
		onClose() {
			this.$emit('close');
		},
		onSave() {
			if (!this.$refs.form.validate()) return;
			let payload = {};
			if (this.template && this.template.Id) {
				payload = JSON.parse(JSON.stringify(this.template));
			}

			payload.Name = this.templateName;
			payload.EntityId = this.selectedEntity;

			if (payload.Id) {
				this.$store
					.dispatch(TemplateActions.UPDATE_TEMPLATE, payload)
					.then((success) => {
						if (!success) return;
						this.$emit('close');
					});
			} else {
				this.$store
					.dispatch(TemplateActions.ADD_TEMPLATE, payload)
					.then((success) => {
						if (!success) return;
						this.$emit('close');
					});
			}
		},
	},
};
</script>
